import { useState, useEffect, useRef } from 'react';

import { useHistory, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  makeStyles, Button, Box, Grid, Snackbar,
} from '@material-ui/core';

import { layoutActions } from './store';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

// import DevicesList from './DevicesList';
import { api_call, console_log, curl_raw_post, empty, get_utc_timestamp_ms, getToken, is_null, trimPhone } from './helpers/untils';
import moment from 'moment';
import { API_BASE_URL, RECAPTCHA_ENABLED, SHARE_ACCESS_TYPE } from './config/constant';
import { getSettingPersist, setSettingPersist } from './helpers/misc';
import CaptchaBox from './components/CaptchaBox';
import { useLocation } from "react-router-dom"
import { Stack } from '@mui/material';
import DOMPurify from "dompurify";

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  sidebar: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    left: 0,
    top: 0,
    margin: theme.spacing(1.5),
    width: theme.dimensions.drawerWidthDesktop,
    bottom: 56,
    zIndex: 1301,
    transition: 'transform .5s ease',
    backgroundColor: 'white',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      margin: 0,
    },
  },
  sidebarCollapsed: {
    transform: `translateX(-${theme.dimensions.drawerWidthDesktop})`,
    marginLeft: 0,
    [theme.breakpoints.down('md')]: {
      transform: 'translateX(-100vw)',
    },
  },
  paper: {
    zIndex: 1,
  },
  toolbar: {
    display: 'flex',
    padding: theme.spacing(0, 1),
    '& > *': {
      margin: theme.spacing(0, 1),
    },
  },
  deviceList: {
    flex: 1,
  },
  sidebarToggle: {
    position: 'absolute',
    left: theme.spacing(1.5),
    top: theme.spacing(3),
    borderRadius: '0px',
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
      left: 0,
    },
  },
  sidebarToggleText: {
    marginLeft: theme.spacing(1),
    [theme.breakpoints.only('xs')]: {
      display: 'none',
    },
  },
  sidebarToggleBg: {
    backgroundColor: 'white',
    color: '#777777',
    '&:hover': {
      backgroundColor: 'white',
    },
  },
}));

const TemporaryVerificationPage = () => {
  //const current = moment();
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const location = useLocation();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { shareUrl } = useParams();
  const params = new URLSearchParams(location.search)

  const [verified, setVerified] = useState(true)
  const refVerifyField = useRef(false)

  const [currentLink, setCurrentLink] = useState(null)
  const refCurLink = useRef({})
  const [currentDeviceId, setCurrentDeviceId] = useState(null)
  const [tempVerificationLink, setTempVerificationLink] = useState()
  const [tempVerificationLinkData, setTempVerificationLinkData] = useState({})
  const [safeHtml, setSafeHtml] = useState("")
  const [turoTripInfo, setTuroTripInfo] = useState({});

  const loadLinkInfo = async () => {
    if (shareUrl) {
      const response = await api_call(`/api/temp-verification-links/${shareUrl}`);
      if (response.ok) {
        const apiResData = await response.json();
        console_log(`apiResData::::`, apiResData);
        const link = apiResData.link;
        setTempVerificationLink(apiResData.tempVerificationLink)
        setTempVerificationLinkData(apiResData.tempVerificationLinkData)
        const pageContent = apiResData.pageContent;
        setSafeHtml(DOMPurify.sanitize(pageContent))
        setTuroTripInfo(apiResData.turoTripInfo)

        setCurrentLink(link)
        refCurLink.current = link
        if (link.captchaRequired) {
          updateCaptchaSettingEnabled(true)
        } else {
          updateCaptchaSettingEnabled(false)
          if (link.email && link.share_setting_enabled) {
            setVerified(true)
            refVerifyField.current = true
          }
        }
        dispatch(layoutActions.setCurrentSharedLink(link));
        setCurrentDeviceId(link.deviceId)
        return true;
      }
      else {
        const errorObj = response
        setToastMessage(errorObj.message || errorObj.error || `Internal server error!`)
        setSnackbarOpen(true)
        return redirectNextPage()
      }
    }

    ////////////////////////////////////////////////////////////
    setToastMessage(`Invalid request!`)
    setSnackbarOpen(true)
    redirectNextPage();
  }

  useEffect(() => {
    loadLinkInfo()
  }, [shareUrl]);

  ///////////// start recaptcha part //////////////////////////////////////////////////////////////////////////
  const captchaKey = 'captcha_temp_verification_link'
  const [recaptcha, setRecaptcha] = useState(RECAPTCHA_ENABLED === "false" ? "xxxxxxxxxxxxxxxxx" : "");
  const [captchaTimestamp, setCaptchaTimestamp] = useState(get_utc_timestamp_ms());
  const updateCaptchaSettingEnabled = (value) => {
    const oldValue = getSettingPersist(captchaKey)
    if (oldValue !== value) {
      setSettingPersist(captchaKey, value)
      setCaptchaTimestamp(get_utc_timestamp_ms())
    }
  }
  ///////////// end recaptcha part //////////////////////////////////////////////////////////////////////////

  const [formData, setFormData] = useState({})
  const onChangeFormInput = (event, field_name) => {
    let form_data = { ...formData }
    form_data[field_name] = event.target.value
    setFormData(form_data)
  }
  const [apiLoading, setApiLoading] = useState(false)

  const updateLinkBorwserIp = async () => {
    const payload = {
      shareUrl: shareUrl
    }
    // const shareUrlType = checkShareUrlType(shareUrl)
    const apiUrl = `/api/update-temp-verification-link-ip-browser`;
    const response = await api_call(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (RECAPTCHA_ENABLED === "true" && empty(recaptcha)) {
      alert("You are not a robot?")
      return false
    }
    setVerified(true)
    refVerifyField.current = true
    updateLinkBorwserIp()
  }

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  ///////////////////////////////////////////////////////////////////////////////////////////////////
  const redirectNextPage = async () => {
    setTimeout(() => {
      history.push("/main")
    }, 2000)
  }

  const linkVerifyForm = () => {
    return (
      <div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ width: '100%', maxWidth: '320px', margin: 'auto' }}>
          <form onSubmit={handleSubmit}>
            <Grid container direction="column" spacing={1}>
              {/* <Grid item>
                <TextField
                  fullWidth
                  value={get_data_value(formData, 'email')}
                  onChange={(event) => onChangeFormInput(event, 'email')}
                  label=""
                  variant="filled"
                  placeholder='Enter email address'
                  inputProps={{ type: 'email' }}
                />
              </Grid> */}
              {
                (RECAPTCHA_ENABLED === "true") && (<>
                  <Grid item>
                    <CaptchaBox
                      recaptcha={recaptcha}
                      setRecaptcha={setRecaptcha}
                      captchaKey={captchaKey}
                      captchaTimestamp={captchaTimestamp}
                    />
                  </Grid>
                </>)
              }
              <Grid item>
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"

                  disabled={apiLoading}
                  fullWidth
                >
                  Go
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </div>
    )
  }

  const updateLinkStatus = async (link, type, status) => {
    const shareUrlType = tempVerificationLink?.share_access_type
    const reservation_id = tempVerificationLink?.reservation_id
    const url = shareUrlType === SHARE_ACCESS_TYPE.SHARED_URL ? `/api/links/update-status` : `/api/trip-access-links/update-status`
    const post_data = {
      shareUrl: link?.shareUrl,
      type: type,
      status: status,
      reservation_id: reservation_id
    }
    const response = await api_call(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(post_data),
    });

    if (response.ok) {
      let responseObj = await response.json()
      setToastMessage(responseObj.message)
      setSnackbarOpen(true)
      // return redirectNextPage()
      await loadLinkInfo();
    } else {
      let errorObj = response
      setToastMessage(errorObj.message || errorObj.error || `Internal server error!`)
      setSnackbarOpen(true)
      return redirectNextPage()
    }
  }

  const onClickApprove = () => {
    const action = 'approved';
    updateLinkStatus(currentLink, tempVerificationLinkData?.type, action)
  }

  const onClickDeny = () => {
    const action = 'denied';
    updateLinkStatus(currentLink, tempVerificationLinkData?.type, action)
  }

  const onClickDownload = () => {
    const m_token = getToken()
    const curTimestamp = moment().format('YYYYMMDD-HHmmss')

    const payload = {
      token: m_token,
      shareUrl: shareUrl,
      tempVerificationLinkId: tempVerificationLink?.id,
      curTimestamp: curTimestamp
    }
    console.log(`onClickDownload payload:::`, payload)
    const urlExport = API_BASE_URL + "/api/temp-verification-link/download";
    curl_raw_post(urlExport, payload, 'post')
  }

  const getApproveStatus = () => {
    let approve_status = ''
    const photo_uploads = currentLink?.photo_uploads
    if (photo_uploads) {
      const photo_uploads_obj = JSON.parse(photo_uploads);
      const key = `${tempVerificationLinkData?.type}_approved`
      approve_status = photo_uploads_obj[key]
    }
    return approve_status;
  }

  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarOpen}
        onClose={() => { setSnackbarOpen(false) }}
        autoHideDuration={1500}
        message={toastMessage}
      />

      <>
        {
          (!empty(currentLink)) ? (
            <>
              {
                (!verified) ? (
                  <>
                    {
                      linkVerifyForm()
                    }
                  </>
                ) : (
                  <>
                    <div className="temp-verification-page" style={{ width: '100%', minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <Box sx={{ width: '100%', maxWidth: '640px', margin: 'auto' }}>
                        <Box sx={{ width: '100%', marginBottom: '24px' }}>
                          <Grid container>
                            <Grid item xs={12} md={4} style={{ textAlign: 'left' }}>
                              <h2>
                                Verify Link{getApproveStatus() === 'approved' ? ' - Approved' : getApproveStatus() === 'denied' ? ' - Denied' : ''}
                              </h2>
                            </Grid>
                            <Grid item xs={12} md={6} style={{ textAlign: 'left' }}>
                              <Box className="temp-link-trip-box" style={{ width: '100%', fontSize: '14px', padding: '8px' }}>
                                <Grid container spacing={1}>
                                  {
                                    (turoTripInfo?.id) ? (
                                      <>
                                        <Grid item xs={6}>
                                          <div><a href={`https://turo.com/reservation/${turoTripInfo?.reservation_id}`} target="_blank" >{turoTripInfo?.reservation_id}</a></div>
                                        </Grid>
                                        <Grid item xs={6}>
                                          <div>
                                            {
                                              (turoTripInfo.car_sharing_url) ? (
                                                <a href={turoTripInfo.car_sharing_url} target="_blank" className='cursor-pointer'>
                                                  {(turoTripInfo.car_photo) && <img src={turoTripInfo.car_photo} width={40} style={{ marginBottom: '0px' }} />}
                                                </a>
                                              ) : (
                                                <>{(turoTripInfo.car_photo) && <img src={turoTripInfo.car_photo} width={40} style={{ marginBottom: '0px' }} />}</>
                                              )
                                            }
                                          </div>
                                        </Grid>
                                        <Grid item xs={12}>
                                          <div>{turoTripInfo.summary.replace('trip with your', '-').replace('is booked!', '').trim()}</div>
                                        </Grid>
                                        <Grid item xs={6}>
                                          <div>
                                            <Stack direction={`row`} spacing={1}>
                                              <a href={`tel:${trimPhone(turoTripInfo.phone, false)}`}>{turoTripInfo.phone}</a>
                                            </Stack>
                                          </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                          <div>{turoTripInfo.primary_driver}</div>
                                        </Grid>
                                        <Grid item xs={12}>
                                          <div>
                                            {
                                              (turoTripInfo.return_location) ? (
                                                <><a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(turoTripInfo.return_location)}`} target="_blank">{turoTripInfo.return_location}</a></>
                                              ) : (
                                                <></>
                                              )
                                            }
                                          </div>
                                        </Grid>
                                        <>
                                          {
                                            (!is_null(turoTripInfo.total_earnings) && Number(turoTripInfo.total_earnings) > 0) && (
                                              <Grid item xs={6}>
                                                <div>{`$${Number(turoTripInfo.total_earnings).toFixed(2)}`}</div>
                                              </Grid>
                                            )
                                          }
                                        </>
                                        <>
                                          {
                                            (!is_null(turoTripInfo.miles_included) && Number(turoTripInfo.miles_included) > 0) && (
                                              <Grid item xs={6}>
                                                <div>{`${Number(turoTripInfo.miles_included).toFixed(0)}`} mile</div>
                                              </Grid>
                                            )
                                          }
                                        </>
                                        <>
                                          {
                                            (!is_null(turoTripInfo.distance) && Number(turoTripInfo.distance) > 0) && (
                                              <Grid item xs={6}>
                                                <div>{`${Number(turoTripInfo.distance).toFixed(0)}`} mile</div>
                                              </Grid>
                                            )
                                          }
                                        </>
                                        <>
                                          {/* {
                                            (!is_null(turoTripInfo.earnings_per_mile) && Number(turoTripInfo.earnings_per_mile) > 0) && (
                                              <Grid item xs={6}>
                                                <div>{`$${Number(turoTripInfo.earnings_per_mile).toFixed(2)}`} / mile</div>
                                              </Grid>
                                            )
                                          } */}
                                          <>
                                            {
                                              (!is_null(turoTripInfo.miles_included) && Number(turoTripInfo.miles_included) > 0) && (
                                                <Grid item xs={6}>
                                                  <div>{`$${(Number(turoTripInfo.total_earnings || 0) / Number(turoTripInfo.miles_included)).toFixed(2)}`} / mile</div>
                                                </Grid>
                                              )
                                            }
                                          </>
                                        </>

                                        {
                                          (tempVerificationLink?.share_access_type === SHARE_ACCESS_TYPE.RESERVATION_ID) ? (
                                            <Grid item xs={12}>
                                              <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                                                <div>{moment(turoTripInfo.start).format('DD-MMM-YY h:mm a')}</div>
                                                <div>-</div>
                                                <div>{moment(turoTripInfo.end).format('DD-MMM-YY h:mm a')}</div>
                                              </Stack>
                                            </Grid>
                                          ) : (
                                            <Grid item xs={12}>
                                              <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                                                <div>{moment(currentLink.from).format('DD-MMM-YY h:mm a')}</div>
                                                <div>-</div>
                                                <div>{moment(currentLink.to).format('DD-MMM-YY h:mm a')}</div>
                                              </Stack>
                                            </Grid>
                                          )
                                        }
                                      </>
                                    ) : (
                                      <>
                                        {
                                          (tempVerificationLink?.share_access_type === SHARE_ACCESS_TYPE.RESERVATION_ID) ? (
                                            <Grid item xs={12}>
                                              <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                                                <div>{moment(turoTripInfo.start).format('DD-MMM-YY h:mm a')}</div>
                                                <div>-</div>
                                                <div>{moment(turoTripInfo.end).format('DD-MMM-YY h:mm a')}</div>
                                              </Stack>
                                            </Grid>
                                          ) : (
                                            <Grid item xs={12}>
                                              <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                                                <div>{moment(currentLink.from).format('DD-MMM-YY h:mm a')}</div>
                                                <div>-</div>
                                                <div>{moment(currentLink.to).format('DD-MMM-YY h:mm a')}</div>
                                              </Stack>
                                            </Grid>
                                          )
                                        }
                                      </>
                                    )
                                  }
                                </Grid>
                              </Box>
                            </Grid>
                            <Grid item xs={12} md={2} style={{ textAlign: isMobile ? 'left' : 'right' }}>
                              <Button type="button" color="primary" variant="contained" onClick={() => onClickDownload()}>Download</Button>
                            </Grid>
                          </Grid>
                        </Box>

                        <div
                          dangerouslySetInnerHTML={{ __html: safeHtml }}
                        />

                        {/* {
                          (tempVerificationLinkData.approve_type === 'manual' || (tempVerificationLinkData.approve_type === 'ai' && tempVerificationLinkData.approve_status === 'pending')) ? (
                            <Box style={{ paddingTop: '12px', textAlign: 'center' }}>
                              <Stack direction={`row`} justifyContent={`center`} alignItems={`center`} spacing={2}>
                                <Button type="button" color="primary" variant="contained" style={{ minWidth: '110px' }} onClick={() => onClickApprove()}>Approve</Button>
                                <Button type="button" color="primary" variant="outlined" style={{ minWidth: '110px' }} onClick={() => onClickDeny()}>Deny</Button>
                              </Stack>
                            </Box>
                          ) : (
                            <></>
                          )
                        } */}

                        <Box style={{ paddingTop: '12px', textAlign: 'center' }}>
                          <Stack direction={`row`} justifyContent={`center`} alignItems={`center`} spacing={2}>
                            <Button type="button" color="primary" variant="contained" style={{ minWidth: '110px' }} onClick={() => onClickApprove()}>Approve</Button>
                            <Button type="button" color="primary" variant="outlined" style={{ minWidth: '110px' }} onClick={() => onClickDeny()}>Deny</Button>
                          </Stack>
                        </Box>

                      </Box>
                    </div>
                  </>
                )
              }
            </>
          ) : (
            <></>
          )
        }
      </>
    </div>
  )
}

export default TemporaryVerificationPage
